type AccessRecord = {
	locations: string[];
	type: string;
};

const accessedFeatureFlags = new Set<string>();
const accessedUnmockedFlags = new Map<string, AccessRecord>();

/**
 * extract file name from error stack trace
 */
const cleanCallSite = (site: string) => {
	if (!site) {
		return '';
	}
	//      'feature-flag' => '    at getCallsite (/Users/XXX/atlassian-frontend-monorepo/jira/src/packages/platform/utils/feature-flagging-mocks/src/utils/usage-tracker/feature-flag-usage-tracker.tsx:33:48)'
	const startIndex = site.indexOf('/');
	const endIndex = site.indexOf(':');
	return site.substring(startIndex, endIndex);
};

/**
 * returns a last location in the code before feature flag access
 */
const getCallsite = () => {
	try {
		// create an error to capture the current callstack
		const error = new Error('error to capture stack');
		const stack = error.stack?.split('\n') || [];

		// try find who accessed `ff` function
		const ffUsage = stack.findIndex((line) => line.includes(' at ff '));

		// try to find who last accessed `getFeatureFlagValue`
		// FIXME: findLastIndex is causing typescript problems: not passing on local, passing on CI. As a result its or precommit or master broken
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
		const ffVUsage: number = (stack as any).findLastIndex((line: string) =>
			line.includes('feature-flagging-using-meta.tsx'),
		);

		// look for direct `ff` usage or the file before feature-mocks
		const stackStart = ffVUsage > 0 ? ffVUsage + 1 : ffUsage;
		if (stackStart < 0) {
			return 'unknown';
		}

		const ffCallerFile = cleanCallSite(stack[stackStart]);
		const featureCallerFile = cleanCallSite(stack[stackStart + 1]);

		// ff used via old interface `feature-flags` file - capture the called in this case
		if (ffCallerFile.includes('feature-flags.tsx')) {
			return featureCallerFile;
		}
		// direct usage
		return ffCallerFile;
	} catch (e) {
		return 'unknown';
	}
};

/**
 * resets test-facing feature flag statistics
 */
export const resetMockedFeatureFlagUsage = () => {
	accessedFeatureFlags.clear();
	accessedUnmockedFlags.clear();
};

/**
 * returns test-facing status of feature flags
 */
export const getMockedFeatureFlagUsage = () =>
	({
		accessed: accessedFeatureFlags,
		unmocked: accessedUnmockedFlags,
	}) as const;

/**
 * registers mocked feature access, only a fact of it
 */
export const registerMockedFeatureAccess = (featureFlagName: string) => {
	accessedFeatureFlags.add(featureFlagName);
};

/**
 * registers unmocked feature flag usage capturing last file accessing it
 */
export const registerUnmockedFeatureAccess = (featureFlagName: string, value: unknown) => {
	accessedFeatureFlags.add(featureFlagName);
	const record = accessedUnmockedFlags.get(featureFlagName) || {
		locations: [],
		type: typeof value,
	};
	record.locations.push(getCallsite());
	accessedUnmockedFlags.set(featureFlagName, record);
};
